import { database } from "../../firebase";

export function getNotifications(uid) {
    return database
        .ref(`/notifications/${uid}`)
        .once("value")
        .then((snapshot) => {
            const array = [];
            snapshot.forEach((childSnapshot) => {
                const key = childSnapshot.key;
                const childData = childSnapshot.val();
                array.push({ key, ...childData });
            });
            return array.filter((a) => a.type === 5 && a.status === 0);
        });
}

export async function getSentNotifications(uid) {
    return database
        .ref(`/notifications`)
        .orderByKey()
        .endAt(uid)
        .once("value")
        .then((snapshot) => {
            const array = [];
            snapshot.forEach((childSnapshot) => {
                const key = childSnapshot.key;
                const childData = childSnapshot.val();
                for (const [k, v] of Object.entries(childData)) {
                    if (typeof v === "object") {
                        if (v.type === 5 && v.uid === uid && v.status === 0) {
                            array.push({ userId: key, key: k, ...v });
                        }
                    }
                }
            });
            return array;
        });
}

export async function createNewNotification(to, payload) {
    const newPostKey = database.ref().child("notifications").push().key;
    const updates = {};
    for (const propName in payload) {
        if (payload[propName] === null || payload[propName] === undefined) {
            delete payload[propName];
        }
    }
    updates[`/notifications/${to}`] = payload;
    // updates[`/user-posts/${uid}/${newPostKey}`] = 1;
    await database.ref().update(updates);
    return { id: newPostKey, ...payload };
}

export function updateNotification(uid, notifId, status) {
    return database
        .ref(`/notifications/${uid}/${notifId}`)
        .update({
            status,
        })
        .then(() => {
            return true;
        })
        .catch(() => false);
}

export async function acceptConnection(uid, userId) {
  debugger;
  const updates = {};
  updates[`/connectuser/${uid}/hello`] = 1;
  await database.ref().update(updates);
  return true;
}
export async function acceptConnectionRequest(uid, userId) {
  debugger;
    const updates = {};
     updates[`/connectuser/${uid}/${userId}/status`] = "Accepted" ;
      await database.ref().update(updates);
     return true;
    // database.ref(`/connectuser/SsxSEzQiq3ajtFgfDiUMarwVdC63/${uid}`).update({ status: "Accepted" });
  }

export function getConnectionIds(uid) {
  return database
    .ref(`/connectuser/${uid}`).orderByChild('status').equalTo('Pending').limitToFirst(4)
    .once("value")
    .then((snapshot) => {
      const array = [];
      snapshot.forEach((childSnapshot) => {
        array.push(childSnapshot.key);
      });
      return array;
    });
}
export function getConnectionrequests(uid) {
  return database
    .ref(`/connectuser/${uid}`).orderByChild('status').equalTo('Pending')
    .once("value")
    .then((snapshot) => {
      const array = [];
      snapshot.forEach((childSnapshot) => {
        array.push(childSnapshot.key);
      });
      return array;
    });
}

export function getUserById(uid) {
    return database
        .ref(`/users/${uid}`)
        .once("value")
        .then((snapshot) => {
            return { uid, ...snapshot.val() };
        });
}

export function findAll() {
    return database
        .ref(`/users`)
        .once("value")
        .then((snapshot) => {
            const array = [];
            snapshot.forEach((childSnapshot) => {
                const uid = childSnapshot.key;
                const childData = childSnapshot.val();
                array.push({ uid, ...childData });
            });
            return array;
        });
}

export async function sendRequest(uid, userId) {
    const newPostKey = database.ref().child("notifications").push().key;
    const updates = {};
    const payload = {
        status: 0,
        timestamp: new Date().getTime(),
        type: 5,
        uid,
    };
    updates[`/notifications/${userId}/${newPostKey}`] = payload;
    await database.ref().update(updates);
}

function getUserData(uid) {
  return new Promise((resolve, reject) => {
    return database.ref("users/" + uid).once("value", (snap) => {
      resolve(snap.val());
    });
  });
}

export function getConnections(uid) {
  return database
    .ref(`/connectuser/${uid}`)
    .once("value")
    .then(async (snapshot) => {
      const array = [];
      snapshot.forEach((childSnapshot) => {
        array.push(childSnapshot.key);
      });
      var results = await Promise.all(
        array.map(async (item) => {
          const data = await getUserData(item);
          return data;
        })
      );
      return array;
    });
}